<div id="particles-js" class='login-page'>
  <div id="login-card" class="login-card">
    <div class="logo">
      <span style="margin: 8px;">
        <img src="assets/icons/logo-branco.png"/>
      </span>
    </div>
    <h1 class="nome">Hackathon Online</h1>
    <p class="txt-cinza">Faça o login para continuar</p>

    <p class="txt-cinza">Digite o código de acesso do hackathon</p>

    <mat-form-field class="input-codigo-acesso">
      <input matInput [(ngModel)]="codigoHack" type="text" required placeholder="Código de acesso" (keydown.enter)="codigoPreenchido()">
    </mat-form-field>

    <button mat-raised-button class="login-button" (click)="codigoPreenchido()">
      <i class="fab fa-google"></i> Google
    </button>
  </div>
</div>

